import React from 'react';

export default function Fishbones() {
	// 4
	let style = {
		st0: {
 			fill:"#FFFFFF"
		},
		st33: {
 			fill:"#E5E5E5"
		}
	};
	return (
		<g>
			<path style={style.st0} d="M168.5691986,421.5116882c0,2.3858032-2.2182465,4.2285461-4.5334778,3.6524963
				c-7.4983368-1.8655701-17.4802551-7.5722351-17.4802551-14.3227234c0-6.7504578,9.9819183-12.4571533,17.4802551-14.3227234
				c2.3152313-0.5760193,4.5334778,1.2666931,4.5334778,3.6525269V421.5116882z"/>
			<path style={style.st0} d="M177.2470856,424.9614258c-0.9755707,0-1.7649994-0.7894287-1.7649994-1.7650146v-24.7098999
				c0-0.9755859,0.7894287-1.7649841,1.7649994-1.7649841s1.7649841,0.7893982,1.7649841,1.7649841v24.7098999
				C179.0120697,424.1719971,178.2226562,424.9614258,177.2470856,424.9614258z"/>
			<path style={style.st0} d="M187.8370514,424.9614258c-0.9755859,0-1.7649994-0.7894287-1.7649994-1.7650146v-24.7098999
				c0-0.9755859,0.7894135-1.7649841,1.7649994-1.7649841c0.9755707,0,1.7649841,0.7893982,1.7649841,1.7649841v24.7098999
				C189.6020355,424.1719971,188.8126221,424.9614258,187.8370514,424.9614258z"/>
			<rect x="166" y="409" style={style.st0} width="49" height="4"/>
			<path style={style.st0} d="M217.6361847,397.6447449l-12.347229,13.1118774l12.2341919,13.7634583
				c1.2478485,1.4038391,3.5484161,0.2449951,3.163147-1.5933228l-2.4394989-11.6400146l2.5169983-12.0098267
				C221.1433716,397.4657593,218.9048157,396.2975464,217.6361847,397.6447449z"/>
			<path style={style.st0} d="M198.427002,421.431427c-0.9755707,0-1.7649841-0.7894287-1.7649841-1.7649841V402.01651
				c0-0.9755859,0.7894135-1.7650146,1.7649841-1.7650146s1.7649994,0.7894287,1.7649994,1.7650146v17.6499329
				C200.1920013,420.6419983,199.4025726,421.431427,198.427002,421.431427z"/>
			<path style={style.st33} d="M161.5351562,415.5512695c-0.3779297,0-0.7558594-0.1416016-1.046875-0.4257812l-6.5849609-6.4194336
				c-0.59375-0.5786133-0.6054688-1.5283203-0.0273438-2.1210938c0.5771484-0.59375,1.5283203-0.605957,2.1210938-0.0273438
				l6.5849609,6.4194336c0.59375,0.5786133,0.6054688,1.5283203,0.0273438,2.1210938
				C162.3154297,415.3999023,161.9257812,415.5512695,161.5351562,415.5512695z"/>
			<path style={style.st33} d="M155.0322266,415.6342773c-0.3779297,0-0.7558594-0.1416016-1.046875-0.4257812
				c-0.59375-0.5786133-0.6054688-1.5283203-0.0273438-2.1210938l6.4199219-6.5854492
				c0.5771484-0.5942383,1.5283203-0.605957,2.1210938-0.0273438c0.59375,0.5786133,0.6054688,1.5283203,0.0273438,2.1210938
				l-6.4199219,6.5854492C155.8125,415.4829102,155.4228516,415.6342773,155.0322266,415.6342773z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Fishbones.js